angular.module('v3sWbtPlayerApp').directive('v3sGraphicThumbnail', ["$rootScope", "v3sContentMediaPath", "$modal", "v3sMediaService", "$window", function ($rootScope, v3sContentMediaPath, $modal, v3sMediaService, $window) {
    return {
        restrict: 'E',
        scope: true,
        link: function (scope, element, attrs) {

            var modal;
            scope.thumbwidth = parseInt(element.attr("v3s-width"));

            var v3sGraphic = element.parent();
            scope.originalwidth = parseInt(v3sGraphic.attr("v3s-width"));
            scope.thumbwidth = parseInt(element.attr("v3s-width"));

            scope.imgSrc = v3sContentMediaPath + scope.v3sFile;
            element.css("background-image", "url(" + scope.imgSrc + ")");

            modal = $modal({
                container: "#wbtContent",
                locals : {
                    $element : element
                },
                scope : scope,
                show: false,
                html: true,
                templateUrl : "app/js/page/elements/v3sGraphicThumbnail.tpl.html",
                controller: ["$element",function ($element) {

                    var mousedownHandler, mousemoveHandler;

                    scope.pan = false;
                    scope.newX = scope.newY = 0;

                    var actualWidth, img, startheight,pageX,pageY;
                    var startwidth = false;

                    scope.imgStyle = {};

                    function setStartWidth(el) {
                        startwidth = el.offsetWidth;
                        startheight = el.offsetHeight;
                        el.parentElement.style.width = startwidth + "px";
                        el.parentElement.style.height = startheight + "px";
                        el.parentElement.classList += " zoomed";
                    }
                    
                    function shrink(el, zoomFactor) {
                        if (!startwidth) {
                            setStartWidth(el);
                        }

                        actualWidth = el.offsetWidth;

                        if (actualWidth <= startwidth) return;

                        if (parseInt(el.style.left) + actualWidth - zoomFactor < startwidth) {
                            el.style.left = parseInt(el.style.left) + zoomFactor + "px";
                        }

                        if (parseInt(el.style.top) + el.offsetHeight - zoomFactor < startheight) {
                            el.style.top = parseInt(el.style.top) + zoomFactor + "px";
                        }

                        el.style.width = actualWidth - zoomFactor + "px";
                    }

                    function grow(el, zoomFactor) {
                        if (!startwidth) {
                            setStartWidth(el);
                        }

                        actualWidth = el.offsetWidth;

                        el.style.maxWidth = "none";
                        el.style.maxHeight = "none";

                        el.style.width = actualWidth + zoomFactor + "px";
                    }

                    this.mousewheel = function ($event) {
                        var delta = Math.max(-1, Math.min(1, ($event.wheelDelta || -$event.detail)));
                        img = $event.target;
                        var zoomFactor = 40;
                        
                        if (delta > 0) {
                            //Hoch
                            grow(img,zoomFactor)
                        } else {
                            shrink(img,zoomFactor)
                        }
                    }

                    this.pinchin = function ($event) {
                        img = $event.target;
                        var zoomFactor = 40;
                      
                        shrink(img, zoomFactor)
                    }

                    this.pinchout = function ($event) {
                        img = $event.target;
                        var zoomFactor = 40;

                        grow(img, zoomFactor);
                    }

                    this.move = function ($event) {
                        if (!scope.pan) return;
                        img = $event.target;
                        if (!startwidth) {
                            setStartWidth(img);
                        }
                        pageX = $event.pageX || $event.pointers[0].pageX;
                        pageY = $event.pageY || $event.pointers[0].pageY;
                        var newLeft = pageX - scope.startX + scope.newX;
                        var newTop = pageY - scope.startY + scope.newY;
                        if (newLeft < 0 && newLeft + img.offsetWidth > startwidth) {
                            img.style.left = newLeft + "px";
                        }
                        if (newTop < 0 && newTop + img.offsetHeight > startheight) {
                            img.style.top = newTop + "px";
                        }
                    }

                    this.down = function ($event) {
                        scope.pan = true;
                        img = $event.target;
                        scope.startX = $event.pageX || $event.pointers[0].pageX;
                        scope.startY = $event.pageY || $event.pointers[0].pageY;
                    }

                    this.up = function ($event) {
                        scope.pan = false;
                        img = $event.target;
                        scope.newX = (img.style.left == "") ? 0 : parseInt(img.style.left);
                        scope.newY = (img.style.top == "") ? 0 : parseInt(img.style.top);

                    }

                }],
                controllerAs : "ctrl"
            });


            modal.$promise.then(function (status) {
                element.on("click touchend", function (evt) {
                    modal.show();
                    evt.preventDefault();
                });
            })
            scope.$on("$destroy", function () {
                if (!!modal) {
                    //Videomodal muss ggf auch zerstört werden
                    modal.destroy();
                    modal = null;
                    scope.pan, scope.startX, scope.startY = null;
                }
            });
        }
    }
}]);